var _link, _link2, _style, _style2, _style3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricetag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1967_21392)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 5.5,
    fill: "#F2F0FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1967_21392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20H32V32H20V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 44H32V56H20V44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 20H56V32H44V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 44H56V54C56 55.1046 55.1046 56 54 56H44V44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20H20V32H8V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 44H20V56H10C8.89543 56 8 55.1046 8 54V44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20H44V32H32V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 44H44V56H32V44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8H32V20H20V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32H32V44H20V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 8H54C55.1046 8 56 8.89543 56 10V20H44V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 32H56V44H44V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 8.89543 8.89543 8 10 8H20V20H8V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 32H20V44H8V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 8H44V20H32V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32H44V44H32V32Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    x1: 9.5,
    y1: 15.6875,
    x2: 54.5,
    y2: 15.6875,
    stroke: "url(#paint0_linear_1967_21392)",
    strokeWidth: 1.125
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    x1: 46.5625,
    y1: 9.5,
    x2: 46.5625,
    y2: 54.5,
    stroke: "url(#paint1_linear_1967_21392)",
    strokeWidth: 1.125
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    x1: 9.5,
    y1: 47.1875,
    x2: 54.5,
    y2: 47.1875,
    stroke: "url(#paint2_linear_1967_21392)",
    strokeWidth: 1.125
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    x1: 17.5625,
    y1: 10,
    x2: 17.5625,
    y2: 55,
    stroke: "url(#paint3_linear_1967_21392)",
    strokeWidth: 1.125
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.8802 21.916L40.9625 23.3572L42.4027 33.4406L33.0405 42.8028C32.8495 42.9937 32.5905 43.101 32.3204 43.101C32.0503 43.101 31.7913 42.9937 31.6003 42.8028L21.517 32.7194C21.326 32.5284 21.2188 32.2694 21.2188 31.9994C21.2188 31.7293 21.326 31.4703 21.517 31.2793L30.8802 21.916ZM33.7606 30.5592C33.9498 30.7483 34.1744 30.8983 34.4215 31.0006C34.6687 31.103 34.9336 31.1556 35.2011 31.1556C35.4686 31.1555 35.7335 31.1028 35.9806 31.0004C36.2278 30.8979 36.4523 30.7479 36.6414 30.5587C36.8306 30.3695 36.9806 30.1449 37.0829 29.8977C37.1852 29.6505 37.2379 29.3856 37.2378 29.1181C37.2378 28.8506 37.1851 28.5857 37.0826 28.3386C36.9802 28.0914 36.8301 27.8669 36.6409 27.6778C36.4517 27.4886 36.2272 27.3386 35.98 27.2363C35.7328 27.134 35.4679 27.0813 35.2004 27.0814C34.6601 27.0815 34.142 27.2962 33.7601 27.6783C33.3781 28.0604 33.1636 28.5786 33.1637 29.1188C33.1638 29.6591 33.3785 30.1772 33.7606 30.5592Z",
    stroke: "#6C47FF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1967_21392",
    x: 1.25,
    y: 4.625,
    width: 61.5,
    height: 61.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.712558 0 0 0 0 0.64 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1967_21392"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.712558 0 0 0 0 0.64 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1967_21392",
    result: "effect2_dropShadow_1967_21392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1967_21392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1967_21392",
    x1: 9.5,
    y1: 17.25,
    x2: 54.5,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C47FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C47FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1967_21392",
    x1: 45,
    y1: 9.5,
    x2: 45,
    y2: 54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C47FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C47FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1967_21392",
    x1: 9.5,
    y1: 48.75,
    x2: 54.5,
    y2: 48.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C47FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C47FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1967_21392",
    x1: 16,
    y1: 10,
    x2: 16,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C47FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#6C47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C47FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1967_21392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 9,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetag);
export default __webpack_public_path__ + "static/media/pricetag.d77ef9214a60c9a1d5e0bb9ed288efce.svg";
export { ForwardRef as ReactComponent };